import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import ActionLink from './ActionLink';
import Tooltip from './Tooltip.js';

const SmartTagPicker = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ display_smarttags, setDisplaySmartTags ] = useState(false);

	const wrapStart = props?.wrapStart ?? '{{';
	const wrapEnd = props?.wrapEnd ?? '}}';

	const addTag = (tag) => {
		props.onSmartTagPick(`${wrapStart}${tag}${wrapEnd}`);
	};

	const content_classes = ['gui_smarttag_picker', 'gui_pos_rel'];
	const toggle_classes = ['RichEditor-styleButton'];
	if(display_smarttags) {
		content_classes.push('is_visible');
		toggle_classes.push('knk-off');
	} else {
		toggle_classes.push('knk-tag');
	}

	return (
		<div
			class={content_classes.join(" ")}
			onMouseEnter={() => setDisplaySmartTags(true)}
			onMouseLeave={() => setDisplaySmartTags(false)}
		>
			<div class={toggle_classes.join(" ")}>{i18n("Smart tags")}</div>

			{(display_smarttags) && (
				<ul class="tags">
					<li><strong>{i18n("Click on a smart tag to add it")}:</strong></li>

					{props.tags.map((tag, t) => {
						return (
							<li key={`tag_${t}`}>
								<ActionLink onClick={() => addTag(tag.tag)}>{tag.label}</ActionLink>
							</li>
						)
					})}
				</ul>
			)}

			<Tooltip autotranslate={false} position="top" link={`${window.zendesk_base_url}207884166/#smartags`}>{`${i18n("Add custom data as smart-tag. They will be replaced by the information they represent when sending the email. Click on the icon to get the available smart-tags list.")}<br /><br />${i18n("Click for more information")}.`}</Tooltip>
		</div>
	);
}

export default injectIntl(SmartTagPicker);